import moment from "moment";
import React, { Component } from "react";
import Button from "../../../components/Button";

class SampleInfoCells extends Component{
    constructor(props){
        super(props);

    }

    render(){
        let {
            person_lastnames, person_name, person_g_rh, person_lectin, person_age, person_sex,
            personPhen, phenotype, personAnti, antibody, number, register_date,
            email_info, print_info
        } = this.props.sampleInfo;

        return(
            <div className="col-xs-12">
                <div className="col-xs-12">
					<div className="col-xs-12 col-sm-8">
						<label>
                            {this.props.labelName}
                        </label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{person_lastnames+' '+person_name }
						</span>
                        <span style={{color:"red", fontSize:"24px", marginLeft:"1em"}}>
							{person_g_rh}
						</span>
                        {(person_lectin !== "" && person_lectin !== "NO PROCESADO") &&
							<label style={{fontSize:"14px", marginLeft:"1em"}}>
								Subgrupo: <span style={{color:"red"}}>{person_lectin}</span>
							</label>
						}
					</div>
					<div className="col-xs-12 col-sm-1">
						<label>Edad:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{person_age}
						</span>
					</div>
					<div className="col-xs-12 col-sm-1">
                        <Button class="btn-info btn-xs" disabled text={person_sex} styles={{width:'100%'}} />
					</div>
				</div>
                <div className="col-xs-12">
					<div className="col-xs-12 col-sm-6">
						<label>{"Fenotipos "+this.props.labelName}</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{personPhen}
						</span>
					</div>
					<div className="col-xs-12 col-sm-6">
						<label>{"Fenotipos "+this.props.labelType}</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{phenotype}
						</span>
					</div>
				</div>

                <div className="col-xs-12">
					<div className="col-xs-12 col-sm-6">
						<label>{"Anticuerpos "+this.props.labelName}</label>
						<span style={{paddingLeft:"10px", color:'red'}} className="theme-color">
							{personAnti}
						</span>
					</div>
					<div className="col-xs-12 col-sm-6">
						<label>{"Anticuerpos "+this.props.labelType}</label>
						<span style={{paddingLeft:"10px", color:'red'}} className="theme-color">
							{antibody}
						</span>
					</div>							
				</div>
                <div className="col-xs-12">
					<div className="col-xs-12 col-sm-6">
						<label>{"No. "+this.props.labelType}</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{number+', '+moment(register_date).format('DD/MM/YYYY HH:mm')}
						</span>
					</div>                    
				</div>
                <div className="col-xs-12 form-group">
                    <div className="col-xs-12 col-sm-6">
                        {email_info !== null &&
                            <div className="col-xs-12 form-group no-padding">
                                <label>Correo enviado: </label>
                                <span style={{paddingLeft:"10px"}} className="theme-color">
                                    {email_info.user+' - '+moment(email_info.timestamp).format('DD/MM/YYYY HH:mm')}
                                </span>
                            </div>
                        }

                        {print_info !== null &&
                            <div className="col-xs-12 form-group no-padding">
                                <label>Impresión: </label>
                                <span style={{paddingLeft:"10px"}} className="theme-color">
                                    {print_info.user+' - '+moment(print_info.timestamp).format('DD/MM/YYYY HH:mm')}
                                </span>
                            </div>
                        }
                    </div>
				</div>
            </div>
        )
    }
}

export default SampleInfoCells;

SampleInfoCells.defaultProps = {
    labelName:'Donante:',
    labelType:'Donación:',
}